import React, {useCallback, useEffect, useRef, useState} from 'react';
import './AIDocumentModal.scss';
import i18next from "i18next";
import BlueButton from "../../Custom UI/Buttons/BlueButton/BlueButton";
import GeneralModal from "../../Modals/GeneralModal/GeneralModal";
import {Translation} from "react-i18next";
import LabeledDelayedInput from "../../Custom UI/LabeledInputs/LabeledDelayedInput/LabeledDelayedInput";

const AIDocumentModal = ({open, save, close}) => {
  
  // Instance Variables
  
  const inputRef = useRef(null);
  
  const [ref, setRef] = useState(null);
  const refSet = useCallback((ref) => {
    setRef(ref);
  }, []);
  
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  
  // Effects
  
  useEffect(() => {
    if(file && file.name && name.length === 0){
      setName(file.name);
    }
  }, [file, name]);
  
  // Render
  
  return (
    // <GeneralModal open={open}
    //               close={close}
    //               width={'calc(100vw - 80px)'}
    //               height={'calc(100vh - 174px)'}
    //               showCancelButton={false}>
    <GeneralModal title={i18next.t('ADD_AI_DOCUMENT')}
                  width={'400px'}
                  height={'350px'}
                  isOpen={open}
                  maxWidth={400}
                  maxHeight={350}
                  handleSave={() => save(file, name)}
                  description={i18next.t('ADD_AI_DOCUMENT_DESCRIPTION')}
                  noTitleHeading={true}
                  showSaveButton={true}
                  handleCloseModal={() => close()}
                  maxChildrenHeight={250}
                  presentedInsideParentModal={true}>
      <LabeledDelayedInput className="ai-document-input"
                           label={i18next.t('AI_DOCUMENT_NAME')}
                           value={name}
                           handleSave={(aEvent) => setName(aEvent.target.value)}
                           placeholder={i18next.t('AI_DOCUMENT_NAME')}
      />
      
      <div className="ai-document-container">
        {file ?
          <div className="ai-document-filename">
            {file.name}
          </div>
          :
          null
        }
      
      <BlueButton className="ai-document-button"
                  name={<Translation>{(t, {i18n}) => t('CHOOSE_FILE')}</Translation>}
                  onClick={() => inputRef.current.click()}
      />
      </div>
      
      <input type="file"
             ref={inputRef}
             style={{display:'none'}}
             accept="application/pdf,.doc,.docx,.txt"
             onChange={(aEvent) => setFile(aEvent.target.files[0])}
      />
    </GeneralModal>
  );
};

export default AIDocumentModal
